import React, { ReactNode } from "react";
import { AccordionRoot } from "@design-system/Accordion/Accordion";
import { DetailsAccordionItem } from "@design-system/Accordion/DetailsAccordionItem";

interface PaneSectionProps {
    title: string;
    defaultExpanded?: boolean;
    // Optional side effect run when the header is clicked (in addition to
    // toggling) — e.g. selecting the section's relationship.
    onHeaderClick?: () => void;
    children: ReactNode;
}

export const PaneSection: React.FC<PaneSectionProps> = ({
    title,
    defaultExpanded = false,
    onHeaderClick,
    children,
}) => (
    <AccordionRoot
        defaultValue={defaultExpanded ? [title] : []}
        onValueChange={() => onHeaderClick?.()}
    >
        <DetailsAccordionItem value={title} label={title}>
            {children}
        </DetailsAccordionItem>
    </AccordionRoot>
);
